import Image from "next/image";
import styles from "./AboutCard.module.css";

const AboutCard = ({ about }) => (
  <div className={`grid h-full w-[255px] rounded-lg shadow-lg lg:w-[349px] ${styles.layout}`}>
    <div className="relative">
      <Image src="/become-consultant/about-card-bg.png" alt="Background" layout="fill" />
      <div className="relative flex h-full flex-col px-5 pt-5 pb-3">
        <div className="relative h-[110px] lg:h-[220px]">
          <Image
            src={`${process.env.NEXT_PUBLIC_STORAGE_URL}/content/${about.picture}`}
            alt={about.title}
            objectFit="cover"
            layout="fill"
            className="absolute rounded-t-lg"
          />
        </div>
        <h3 className="mt-3 text-center font-semibold text-grey-900 lg:text-xl">{about.title}</h3>
      </div>
    </div>
    <p className="py-6 px-5 text-sm text-grey-700">{about.text}</p>
  </div>
);

export default AboutCard;
